import { Component, output, input, model } from '@angular/core';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';

/**
 * The „von / bis" pair of the list filters (#199: five search components each carried their own
 * copy). Renders two grid columns and nothing around them — the host is `display: contents`, so
 * it sits in the caller's `.row` beside that filter's other fields.
 *
 *   <app-date-range-filter [(from)]="filter.dateFrom" [(to)]="filter.dateTo" (rangeChange)="search()">
 *
 * `rangeChange` fires after `fromChange` / `toChange`, so the caller's filter already holds the
 * picked date when it searches.
 */
@Component({
  selector: 'app-date-range-filter',
  imports: [DatePickerModule],
  templateUrl: './date-range-filter.component.html',
  // `display: contents` lets the two columns sit directly in the caller's `.row` — but it also
  // means Bootstrap's `.row > *` gutter rule lands on this host, where padding does nothing, and
  // not on the columns themselves (#228: the date fields stood 8px left of every other field and
  // lost the row's vertical gutter). The custom properties inherit from the row, so the columns
  // can take the very same rule.
  styles: [
    `
      :host { display: contents; }
      :host > div {
        padding-right: calc(var(--bs-gutter-x, 1.5rem) * 0.5);
        padding-left: calc(var(--bs-gutter-x, 1.5rem) * 0.5);
        margin-top: var(--bs-gutter-y, 0);
      }
    `,
  ],
})
export class DateRangeFilterComponent {
  /** Two-way bound: `set()` updates the value and emits `fromChange` / `toChange` in one step. */
  readonly from = model<Date>();
  readonly to = model<Date>();
  readonly rangeChange = output<void>();

  readonly fromLabel = input($localize`Datum von`);
  readonly toLabel = input($localize`Datum bis`);
  readonly columnClass = input('col-12 col-md-3');
  /** `<testId>-from` / `<testId>-to` on the two pickers, for the E2E suite. */
  readonly testId = input<string>();

  public onFromChange(date: Date): void {
    this.from.set(date);
    this.rangeChange.emit();
  }

  public onToChange(date: Date): void {
    this.to.set(date);
    this.rangeChange.emit();
  }
}
